module.exports = __webpack_public_path__ + "media/images/flags/16/Cambodia-941a1ac52f2ec507c7b07e63aeab453b.png";